/**
 * Attention Items Context
 * Provides attentionItems to OwnerLayout and other components
 */

import { createContext, useContext } from 'react';

const AttentionItemsContext = createContext({
  attentionItems: [],
  setAttentionItems: () => {},
});

export function AttentionItemsProvider({ children, attentionItems = [] }) {
  return (
    <AttentionItemsContext.Provider value={{ attentionItems }}>
      {children}
    </AttentionItemsContext.Provider>
  );
}

export function useAttentionItems() {
  const context = useContext(AttentionItemsContext);
  if (!context) {
    // Return empty array if context not available (graceful degradation)
    return { attentionItems: [] };
  }
  return context;
}

